let config = null;

export async function loadAppConfig() {
    const response = await fetch("/config.json", { cache: "no-cache" });
    config = await response.json();
}

export function getAppConfig() {
    if (!config) {
        throw new Error("Config not loaded. Call loadAppConfig() before using it.");
    }
    return config;
}

export const configurationIdentityServer = () => {
    const { authServerUrl } = getAppConfig();
    return {
        client_id: "LinqWebApp01",
        redirect_uri: window.location.origin + "/callback",
        silent_redirect_uri: window.location.origin + "/authentication/callback",
        scope: "openid api1.access ticket.generator",
        authority: authServerUrl,
        service_worker_only: false,
    };
};
